import { Component, OnInit, Input } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';

@Component({
    selector: 'app-table-rating-badge',
    templateUrl: './rating-badge.component.html',
    styleUrls: ['./rating-badge.component.css'],
    standalone: false
})
export class TableRatingBadgeComponent extends TableElementComponent implements OnInit {
    averageRate: number = 0.0;
    big: boolean = false;
    small: boolean = false;

    override ngOnInit(): void {
        if(this.data.averageRate){
            this.averageRate = this.data.averageRate;
        } else if(this.data.rates) {
            this.averageRate = this.data.rates;
        }
        if(this.props.big){
            this.big = this.props.big
        }
    }

}
